module.exports = __webpack_public_path__ + "static/media/Notice of Proposal to Refuse an Application and Revoke Licences.e584ce21.pdf";